import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, Optional, PLATFORM_ID } from "@angular/core";
import { AuthorizationService } from "./services/authorization.service";
import { REQUEST } from "@nguniversal/express-engine/tokens";
import * as isbot from "isbot";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "nuty";
  public isLogin: boolean;
  isLoadingApplication = true;

  constructor(
    private authService: AuthorizationService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private request: Request
  ) {
    this.isLogin = this.authService.isLogin();

    this.authService.isLoginObservable().subscribe((data) => {
      this.isLogin = data.login;
    });

    if (isPlatformBrowser(this.platformId)) {
      this.isLoadingApplication = false;
    } else {
      if (isbot(this.request.headers["user-agent"])) {
        this.isLoadingApplication = false;
      }
    }
  }
}
